module.exports = "/_next/static/images/streamline-operations-23793ea98ac74e665ca16ef6a1e50aa7.svg";